<template>
  <div class="edit-in-place" :class="[{edit :isEditMode},{multiline: isMultiline}, format]" v-tooltip="'Click to edit'">
    <input ref="input"
      v-if="!isMultiline" 
      v-model="innerValue"
      @change="saveEdit"
      @focus="isEditMode = true"
      v-click-outside="() => isEditMode && saveEdit()"
      @blur="saveEdit"
      :placeholder="placeholder" />
    <textarea ref="input"
      v-if="isMultiline" 
      v-model="innerValue"
      @change="saveEdit"
      @focus="isEditMode = true"
      v-click-outside="() => isEditMode && saveEdit()"
      @blur="saveEdit"
      :placeholder="placeholder"
      wrap="soft"
      v-show="isEditMode"
      @keypress="onTestChange"
      />
    <div class="text-spacer" :class="{placeholder: !value}" ref="text" @click.stop="()=> isEditMode=true">{{value || 'Add description'}}</div>
  </div>
</template>

<script>
export default {
  name: "EditInPlace",
  props: ['value', 'format', 'placeholder', 'isMultiline'],
  data () {
    return {
      innerValue: this.value,
      isEditMode: false
    }
  },
  computed: {
    bindHeight () {
      return this.$refs.text ? this.$refs.text.clientHeight : 25
    }
  },
  methods: {
    saveEdit(){
      this.isEditMode = false
      this.$refs.input.blur()
      if(this.innerValue != this.value) {
        this.$emit('input', this.innerValue)
      }
    },
    onTestChange(evt) {
      let key = evt.keyCode;
      // If the user has pressed enter
      if (key === 13) {
        this.saveEdit()
      }
    }
  }

}
</script>

<style lang="stylus">
.edit-in-place
  margin-left -6px
  position relative
  m-font-size(16,22)
  display: inline-block
  &.multiline
    width 100%
  .text-spacer
    padding 5px
    margin-right 10px
    min-height 25px
    color $trout
    border 1px solid transparent
    m-font-size(16,22)
    border-radius 4px
    font-weight $fw-regular
    &:hover
      border 1px solid $heather
    &.placeholder
      color: $spun-pearl


  &.title
    m-font-size(32,40)
    font-weight $fw-bold
    input, textarea, .text-spacer
      m-font-size(32,40)
      font-weight $fw-bold
  input, textarea,
    position: absolute;
    font-family $base-font-family
    min-width 250px
    left: 0
    color $trout
    m-font-size(16,22)
    font-weight $fw-regular
    height 100%
    width 100%
    border 1px solid $titan-white
    background $titan-white
    border-radius 4px
    outline none
    resize none
    margin-bottom 4px
    min-height 25px

    &::placeholder
      color: $spun-pearl

    &:hover
      border 1px solid $heather
  textarea
    width 100%
  &.edit
    input, textarea
      height 100%
      border 1px solid $heather
      border-radius 4px
      background #fff
</style>